import React, { useEffect, useState } from "react";
import "./style.css";
import axios from "axios";
import HeaderEn from "../header-en";
import FooterEn from "../footer-en";

const engText = require("../../../utils/screeningEnglishTexts.js");
const faText = require("../../../utils/screeningFarsiTexts.js");

function ScreeningTicketEn(props) {
  const [sendMessage, setSendMessage] = useState(
    "Hello,I'mInScreeningTicketPageEn"
  );

  useEffect(() => {
    handleRedirect();
    window.location.href = "/en/products/autism-screening-ticket";
  }, []);

  const handleRedirect = async () => {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: sendMessage,
    });
    return true;
  };

  return (
    <div>
      <HeaderEn />
      <div className="screening-container-loading" style={{ height: "90vh" }}>
        <h1>You are redirecting, Please wait ...</h1>
      </div>
      <FooterEn />
    </div>
  );
}

export default ScreeningTicketEn;
